import React from "react";
import SecondaryButton from "../buttons/SecondaryButton";

const SlideFooter = ({ handleSubmit, closePopup, disableSubmit }) => {
  return (
    <div className="absolute shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 bottom-[0] right-[0] w-full bg-white flex gap-5">
      <button
        onClick={handleSubmit}
        disabled={disableSubmit}
        className="btn-primary-base-bar primary_btn flex items-center bg-[#245CEA] text-white py-2 px-5 rounded-[5px] hover:bg-white border hover:border-[#245CEA] hover:text-[#1A1A1B] transition duration-300 h-[42px] text-[16px] font-mont font-[600]"
      >
        Submit
      </button>
      <SecondaryButton label="Cancel" onClick={closePopup} />
    </div>
  );
};

export default SlideFooter;
